import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>("faq-01");

  return (
    <section id="faq" className="py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
          <div>
            <SectionHeading
              eyebrow="常见问题"
              title="关于这个平台，你可能想问"
              description="从「时间线是什么」到「信息是否可靠」，我们把最常被问到的几个问题整理在这里。如果你还有疑问，欢迎拉到页脚给我们留言。"
            />
            <div className="mt-6 hidden rounded-2xl border border-primary-200 bg-primary-50 p-5 lg:block">
              <div className="flex items-center gap-2 text-sm font-bold text-primary-800">
                <i className="ri-shield-check-line text-lg" />
                一条提醒
              </div>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-700">
                涉及定性或法律的事项，请务必以监管部门、司法机关与权威机构的正式发布为准，我们的时间线仅作信息整理参考。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((f) => {
              const open = openId === f.id;
              return (
                <div
                  key={f.id}
                  className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : f.id)}
                    aria-expanded={open}
                    className="flex w-full items-center gap-3 p-5 text-left"
                  >
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                      <i className="ri-question-line" />
                    </span>
                    <span className="flex-1 text-sm font-semibold text-foreground-900 md:text-base">{f.q}</span>
                    <i
                      className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform ${open ? "rotate-180" : ""}`}
                    />
                  </button>
                  {open ? (
                    <p className="border-t border-background-200 bg-background-100/50 px-5 py-4 pl-[60px] text-sm leading-relaxed text-foreground-700">
                      {f.a}
                    </p>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}